<template>
  <v-card flat tile class="elevation-1" :loading="loading" :disabled="!isEditable">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card-text>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn fab text depressed small absolute right v-on="on">
                  <v-icon dark>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in projectTabItems"
                  :key="index" :to="item.to">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <al-project-breadcrumb></al-project-breadcrumb>
          </v-card-text>
          <v-card-title title="Project title" class="py-0 black--text">
            {{ projectInfo.name }}
            <v-btn text small icon class="ml-1"
              color="accent" @click="init"
              title="Refresh">
              <v-icon dark>mdi-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>{{ projectInfo.projectType }} - {{ projectInfo.category }}</v-card-text>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="3" v-if="!hideProject">
          <v-navigation-drawer width="100%" permanent height="calc(100vh - 190px)">
            <v-list dense nav subheader :disabled="!isEditable">
              <v-subheader>Navigate</v-subheader>

              <v-list-item color="accent"
                v-for="(item, index) in projectTabItems"
                link :key="index"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </v-col>
        <v-col :cols="hideProject ? 12 : 9">
          <router-view
            :loading="loading" :project="projectInfo"
            :isEditable="isEditable"
            @update="onProjectUpdate"
          ></router-view>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import types from '@/store/types';

export default {
  name: 'project-parent-page',
  data: () => ({
    loading: false,
    projectInfo: {},
    hideProject: false,
    invalid: false,
  }),
  computed: {
    ...mapGetters('routes', ['projectTabItems']),
    projectId() {
      return this.$route.params.projectId;
    },
    isEditable() {
      return !this.invalid && !this.loading;
    },
  },
  methods: {
    ...mapActions('db', {
      getProject: types.GET_PROJECT_BY_ID,
    }),
    onProjectUpdate($event) {
      this.projectInfo = {
        ...this.projectInfo,
        ...$event,
      };
    },
    handleSidebar(route) {
      this.hideProject = !!route.meta.hideProject;
    },
    init() {
      const payload = {
        id: this.projectId,
      };
      this.loading = true;
      this.getProject(payload).then((res) => {
        this.projectInfo = res || {};
        this.loading = false;
        this.invalid = false;
      }).catch((error) => {
        this.invalid = true;
        this.loading = false;
        if (error.code === 'permission-denied') {
          this.$router.replace('/');
        }
      });
    },
  },
  created() {
    this.handleSidebar(this.$route);
    this.init();
  },
  watch: {
    $route(to) {
      this.handleSidebar(to);
    },
  },
};
</script>
